import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../common/tenvicCommon/FunctionCalls";
import * as api from "../common/tenvicCommon/API";
import Select from "react-select";
import { usePermissions } from "../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../common/tenvicCommon/Utils";

const Users = () => {

    const [usersList, setUsersList] = useState<any[]>([]);
    const [rolesList, setRolesList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [roleId, setRoleId] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [userStatus, setUserStatus] = useState("");
    const [password, setPassword] = useState("");
    const [usrId, setUsrId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchUsers() {
            setIsLoading(true);
            const usersResponse = await func.listUsers();
            setUsersList(Array.isArray(usersResponse) ? usersResponse : [])
            setIsLoading(false);
        }
        fetchUsers();
    }, [])

    const filteredData = usersList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const firstNameRender = (rowData) => {
        return <span>{rowData.internalUserFirstName}</span>;
    };

    const lastNameRender = (rowData) => {
        return <span>{rowData.internalUserLastName}</span>;
    };

    const roleRender = (rowData) => {
        return <span>{rowData.internalRoleName}</span>;
    };

    const userNameRender = (rowData) => {
        return <span>{rowData.internalUserUserName}</span>;
    };

    const emailRender = (rowData) => {
        return <span>{rowData.internalUserEmail}</span>;
    };

    const phoneRender = (rowData) => {
        return <span>{rowData.internalUserPhone}</span>
    }

    const userStatusRender = (rowData) => {
        return <span>{(rowData.internalUserStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editUser(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const usrId = rowData.internalUserId;
        return (
            <Link to="#" onClick={() => deleteUser(usrId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newUser() {
        setIsEdit(false)
        setOpenModal(true)
        const roleResponse = await func.listRoles();
        setRolesList(Array.isArray(roleResponse) ? roleResponse : [])
        setFirstName("");
        setLastName("");
        setUserName("");
        setEmail("");
        setPhone("");
        setPassword("");
        setRoleId("");
    }


    async function editUser(rowData: { internalUserId: string | number; }) {
        const usrId = rowData.internalUserId;
        setIsEdit(true)
        setOpenModal(true)
        setRolesList(await func.listRoles())
        const getDetails = await func.getUser(usrId);
        setUsrId(usrId);
        setFirstName(getDetails.internalUserFirstName);
        setLastName(getDetails.internalUserLastName);
        setUserName(getDetails.internalUserUserName);
        setEmail(getDetails.internalUserEmail);
        setPhone(getDetails.internalUserPhone);
        setRoleId(getDetails.internalUserRoleId);
        setUserStatus(getDetails.internalUserStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateUser();
            } else {
                if (firstName && lastName && userName && email && phone && roleId) {
                    const formData = new FormData();
                    formData.append("firstName", firstName);
                    formData.append("lastName", lastName);
                    formData.append("email", email);
                    formData.append("userName", userName);
                    formData.append("password", password);
                    formData.append("phone", phone);
                    formData.append("role", roleId);

                    const createUser = api.CreateUser;
                    fetch(createUser, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            console.log(result);

                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                const messages = Object.values(result.message).join('\n');
                                Swal.fire({
                                    title: 'Error',
                                    text: messages,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateUser() {
        const formData = new FormData();
        formData.append("firstName", firstName);
        formData.append("lastName", lastName);
        formData.append("email", email);
        formData.append("userName", userName);
        formData.append("phone", phone);
        formData.append("role", roleId);
        formData.append("internalUserStatus", userStatus);

        const updateRole = api.UpdateUser + '/' + usrId;
        fetch(updateRole, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteUser(usrId) {
        const deleteUsr = api.DeleteUser + '/' + usrId;
        fetch(deleteUsr, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Users</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newUser() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create User">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalUserFirstName"
                                                header="First Name"
                                                body={firstNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalUserLastName"
                                                header="Last Name"
                                                body={lastNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalUserUserName"
                                                header="User Name"
                                                body={userNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalRoleName"
                                                header="Role Name"
                                                body={roleRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalUserEmail"
                                                header="Email"
                                                body={emailRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalUserPhone"
                                                header="Phone"
                                                body={phoneRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalUserStatus"
                                                header="User Status"
                                                body={userStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="xl"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} User</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="input-space">
                                            <label className="form-label">First Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="firstname"
                                                placeholder="Enter First Name"
                                                required
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="input-space">
                                            <label className="form-label">Last Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="lastname"
                                                placeholder="Enter Last Name"
                                                required
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="input-space">
                                            <label className="form-label">User Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="username"
                                                placeholder="Enter User Name"
                                                required
                                                value={userName}
                                                onChange={(e) => setUserName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="input-space">
                                            <label className="form-label">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder="Enter Email Address"
                                                required
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="input-space">
                                            <label className="form-label">Phone</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="phone"
                                                placeholder="Enter Phone"
                                                required
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {!isEdit ? <>
                                        <div className="col-lg-6">
                                            <div className="input-space">
                                                <label className="form-label">Password</label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    id="password"
                                                    placeholder="Enter Password"
                                                    required
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </> : null}
                                    <div className="col-lg-6">
                                        <div className="input-space">
                                            <label className="form-label">Role</label>
                                            <Select
                                                value={rolesList.find(role => role.internalRoleId === roleId) ? {
                                                    value: roleId,
                                                    label: rolesList.find(role => role.internalRoleId === roleId).internalRoleName
                                                } : null}
                                                onChange={async (e) => {
                                                    setRoleId(e.value);
                                                }}
                                                required
                                                placeholder="Select Role"
                                                options={rolesList.map(role => ({
                                                    value: role.internalRoleId,
                                                    label: role.internalRoleName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={userStatus === '1'}
                                                        id="userStatus"
                                                        onChange={(e) => {
                                                            setUserStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default Users;